import { render, staticRenderFns } from "./ModalUserDelete.vue?vue&type=template&id=21637c44&"
import script from "./ModalUserDelete.vue?vue&type=script&lang=js&"
export * from "./ModalUserDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports